import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SpeedDial = _resolveComponent("SpeedDial")!
  const _component_vue_excel_column = _resolveComponent("vue-excel-column")!
  const _component_vue_excel_editor = _resolveComponent("vue-excel-editor")!
  const _component_ValidationTableExcelReorderDialog = _resolveComponent("ValidationTableExcelReorderDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "validation-table-excel",
    onKeydownCapture: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onEditorKeydown && _ctx.onEditorKeydown(...args)))
  }, [
    (_ctx.speedDialActions.length > 0)
      ? (_openBlock(), _createBlock(_component_SpeedDial, {
          key: 0,
          model: _ctx.speedDialActions,
          direction: "up",
          class: "validation-table-excel__speed-dial",
          transitionDelay: 80,
          buttonClass: "validation-table-excel__speed-dial-button",
          tooltipOptions: { position: 'left' },
          onShow: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSpeedDialOpen = true)),
          onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSpeedDialOpen = false)),
          pt: {
				action: {
					class: 'validation-table-excel__speed-dial-action',
				},
				actionIcon: {
					class: 'validation-table-excel__speed-dial-action-icon',
				},
			}
        }, {
          button: _withCtx(({ toggleCallback }) => [
            _withDirectives(_createVNode(_component_Button, {
              type: "button",
              icon: _ctx.isSpeedDialOpen ? 'mdi mdi-table-arrow-up' : 'mdi mdi-table-arrow-down',
              class: "p-speeddial-button p-button-rounded validation-table-excel__speed-dial-button",
              "aria-label": _ctx.$t('Squeeze.Validation.Buttons.TableOptions'),
              "aria-expanded": _ctx.isSpeedDialOpen,
              "aria-haspopup": "true",
              onClick: toggleCallback
            }, null, 8, ["icon", "aria-label", "aria-expanded", "onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('Squeeze.Validation.Buttons.TableOptions'),
                void 0,
                { left: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "validation-table-excel__editor",
      onMousedownCapture: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onEditorMouseDown && _ctx.onEditorMouseDown(...args)))
    }, [
      (_openBlock(), _createBlock(_component_vue_excel_editor, {
        key: _ctx.editorInstanceKey,
        ref: "excelEditor",
        modelValue: _ctx.editorRows,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editorRows) = $event)),
        selectedCount: _ctx.selectedCount,
        "onUpdate:selectedCount": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCount) = $event)),
        readonly: _ctx.isReadOnlyMode,
        "no-paging": true,
        "no-mouse-scroll": true,
        "filter-row": false,
        "no-num-col": false,
        "localized-label": _ctx.localizedLabel,
        "row-style": _ctx.getRowStyle,
        "cell-style": _ctx.getCellStyle,
        "no-header-edit": true,
        "disable-panel-setting": true,
        "disable-panel-filter": "",
        "no-mass-update": "",
        enterToSouth: "",
        width: "100%",
        "no-footer": "",
        onSetting: _ctx.onEditorSetting,
        onSelect: _ctx.onRowSelectionChange,
        onCellFocus: _ctx.onCellFocus,
        onDelete: _ctx.onDeleteRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vue_excel_column, {
            field: "$id",
            type: "string",
            label: "",
            "key-field": "",
            invisible: "",
            readonly: ""
          }),
          _createVNode(_component_vue_excel_column, {
            field: "rowPosition",
            type: "number",
            label: _ctx.$t('Squeeze.Validation.General.PositionHeadline'),
            width: "64px",
            change: _ctx.onRowPositionChange
          }, null, 8, ["label", "change"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (column, columnIndex) => {
            return (_openBlock(), _createBlock(_component_vue_excel_column, {
              key: column.id ?? column.name,
              field: column.name ?? '',
              label: _ctx.getTranslatedDescription(column) || column.name || '',
              type: _ctx.getColumnType(column),
              width: _ctx.getColumnWidth(column, columnIndex),
              autoFillWidth: columnIndex === _ctx.visibleColumns.length - 1,
              readonly: column.readonly ? true : undefined,
              autocomplete: _ctx.isLookupColumn(column),
              options: _ctx.getLookupOptions(column),
              "to-value": _ctx.toEditorValue,
              "to-text": _ctx.toEditorText,
              change: (newValue, oldValue, row) => _ctx.onCellChange(column, newValue, oldValue, row)
            }, null, 8, ["field", "label", "type", "width", "autoFillWidth", "readonly", "autocomplete", "options", "to-value", "to-text", "change"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "selectedCount", "readonly", "localized-label", "row-style", "cell-style", "onSetting", "onSelect", "onCellFocus", "onDelete"]))
    ], 32),
    _createVNode(_component_ValidationTableExcelReorderDialog, {
      visible: _ctx.showReorderDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showReorderDialog) = $event)),
      title: _ctx.$t('Squeeze.Validation.Buttons.ChangeSorting'),
      rows: _ctx.reorderDialogRows,
      readonly: _ctx.isReadOnlyMode,
      onReorder: _ctx.onRowsReordered
    }, null, 8, ["visible", "title", "rows", "readonly", "onReorder"])
  ], 32))
}